exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#loginSettingsModal .v--modal-box.v--modal{min-width:430px!important;min-height:240px!important}#loginSettingsModal .v-text-field__slot input,#loginSettingsModal .v-text-field__slot label{font-size:12px}#loginSettingsModal .v-messages__message{line-height:1.2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d6e489c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/loginSettings/LoginSettings.vue
// module id = 1925
// module chunks = 0